import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import CustomStep from 'workOrderComponents/close/CustomStep';
import TicketComment from 'ticketComponents/TicketComment';

class DropBuryStep extends React.Component {

    constructor(props) {
        super(props);

        this.handleRadioGroupChange = this
            .handleRadioGroupChange
            .bind(this);

    }

    handleRadioGroupChange(e, value) {
        const { workOrderActions, orderId} = this.props;
        if (value === 'yes') {
            workOrderActions.ticketRequestAdd({
                workType: 'DropBury'
            }, orderId);
        }

        if (value === 'no') {
            workOrderActions.ticketRequestRemove('DropBury', orderId);
        }

        workOrderActions.dropBurySet(value, orderId);
    }

    render() {
        const { workOrderActions, orderCloseDetails, stepConfig, orderId, disabled } = this.props;

        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');

        let exsistingTicket = null;

        if (orderCloseDetails.getIn(['closeOrderRequest', 'ticketRequests'])) {

            exsistingTicket = orderCloseDetails
                .getIn(['closeOrderRequest', 'ticketRequests'])
                .find((item) => {

                    return item.get('workType') === 'DropBury';

                });
        }

        const isValid = stepValidation.getIn(['dropBury', 'isValid']);
        const currentValue = orderCloseDetails.getIn(['auxiliary', 'dropBury']);

        return (
            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`${!isValid ? 'Drop Bury' : `Drop Bury - ${exsistingTicket
                    ? 'Yes'
                    : 'No'}`}`}
                stepConfig={stepConfig}
                stepConfigKey="dropBuryStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="dropBury">

                <div className="margin-top-and-bottom threefourths-em">

                    <RadioButtonGroup
                        style={{
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                        onChange={this.handleRadioGroupChange}
                        name="dropBury"
                        valueSelected = {currentValue ? currentValue : null}>
                        <RadioButton
                            disabled={disabled}
                            value="no"
                            label="No"
                            style={{
                                display: 'inline-block'
                            }} />
                        <RadioButton
                            disabled={disabled}
                            value="yes"
                            label="Yes"
                            style={{
                                display: 'inline-block'
                            }} />
                    </RadioButtonGroup>

                    <TicketComment
                        workType="DropBury"
                        disabled={disabled}
                        workOrderActions={workOrderActions}
                        orderCloseDetails={orderCloseDetails}
                        orderId={orderId} />

                </div>
            </CustomStep>
        );

    }
}

DropBuryStep.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    stepConfig: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool
};

export default DropBuryStep;



// WEBPACK FOOTER //
// ./src/components/ticket/DropBuryStep.js